import React, {useEffect, useMemo} from "react";
import Heading from "../../../../components/Heading";
import Text from "../../../../components/Text";
import {useTranslation} from "react-i18next";
import {useIndividualizationContext} from "../../../../contexts/individualizationContext";
import {Article} from "../../../../types/Article";
import Select from "../../../../components/Select";
import parseStringToHTML from "../../../../helpers/parseStringToHTML";
import cx from "classnames";
import styles from "./DetermineSurchargeType.module.css"
import {useFetchData} from "../../../../hooks/useFetchData";

const DetermineSurchargeType: React.FC = () => {
    const {t} = useTranslation(['individualization']);

    const {
        activeStep,
        templates,
        spots,
        updateSpotData,
        changeTemplateSurcharge,
        globalSurcharge,
        updateGlobalSurcharge
    } = useIndividualizationContext()

    const {
        data: surchargeArticles,
        fetch
    } = useFetchData<Article>('surchargeArticles')

    useEffect(() => {
        fetch()
    },[fetch])

    const updateTemplateSurcharge = (template_id: string|number, kArtikel: string) => {
        changeTemplateSurcharge(template_id, kArtikel)
    }

    const updateSpotSurcharge = (spot_id: string, kArtikel: string) => {
        updateSpotData(spot_id, 'surcharge_kArtikel', kArtikel)
    }

    const surchargeOptions = useMemo(() => {
        return surchargeArticles.map((article) => ({
            label: article.cName + ' (' + article.cArtNr + ') ' + parseStringToHTML(article.price[1]),
            value: article.kArtikel
        }))
    }, [surchargeArticles])

    return activeStep === 3 ? (
        <>
            <Heading level={3} classes={'mt-4'}>{t('progress.determine_surcharges')}</Heading>
            <Text classes={'my-4'}>{t("determine_surcharges.description")}</Text>
            <div className={cx(styles['template-wrapper'])}>
                <div className={cx(styles['element-wrapper'])}>
                    <Heading level={3} classes={'w-100'}>{t('determine_surcharges.total_surcharge')}</Heading>
                    <Select
                        options={surchargeOptions}
                        onSelect={(property, value) => updateGlobalSurcharge(value)}
                        property={'global_surcharge'}
                        value={globalSurcharge ?? ''}
                        placeholder={t('determine_surcharges.surcharge_article')}
                        classes={cx(styles['element-select'])}
                        searchable={false}
                    />

                </div>
            </div>
            {templates.map((template) => {
                return (
                    <div className={cx(styles['template-wrapper'])}>
                        <div className={cx(styles['element-wrapper'])}>
                            <Heading level={4} classes={'w-100'}>{template.name}</Heading>
                            <Select
                                options={surchargeOptions}
                                onSelect={(property, value) => {
                                    updateTemplateSurcharge(template.id, value)
                                }}
                                property={'surcharge_kArtikel'}
                                value={template.surcharge_kArtikel ?? ''}
                                placeholder={t('determine_surcharges.surcharge_article')}
                                classes={cx(styles['element-select'])}
                            />
                        </div>
                        {spots.filter((spot) => spot.data.template_id === template.id).map((spot) => {
                            return (
                                <div className={cx(styles['element-wrapper'])}>
                                    <Text classes={'w-100'}>{spot.data.name}</Text>
                                    <Select
                                        options={surchargeOptions}
                                        onSelect={(property, value) => {
                                            updateSpotSurcharge(spot.data.id, value)
                                        }}
                                        property={'surcharge_kArtikel'}
                                        value={spot.data.surcharge_kArtikel ?? ''}
                                        placeholder={t('determine_surcharges.surcharge_article')}
                                        classes={cx(styles['element-select'])}
                                        searchable={false}
                                    />
                                </div>
                            )
                        })}
                    </div>
                )
            })}
        </>
    ) : null
}

export default DetermineSurchargeType
